<div class="tenant-sso">
  <a href="javascript:void(0)" class="back-link" (click)="goBack()">
    <i class="bi bi-chevron-left"></i> Back to Overview
  </a>

  <div class="d-flex justify-content-between align-items-start mb-3">
    <div>
      <h2 class="page-title">Security (SSO)</h2>
      <p class="page-subtitle">Manage SSO and authentication settings</p>
    </div>
    @if (!loading) {
      @if (!isEditing) {
        <button type="button" class="btn edit-btn" (click)="toggleEdit()">
          <i class="bi bi-pencil"></i> Edit
        </button>
      } @else {
        <div class="d-flex gap-2">
          <button type="button" class="btn cancel-btn" (click)="toggleEdit()" [disabled]="saving">Cancel</button>
          <button type="button" class="btn save-btn" (click)="save()" [disabled]="saving">
            @if (saving) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            } @else {
              <i class="bi bi-check-lg"></i> Save Changes
            }
          </button>
        </div>
      }
    }
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loader />
    </div>
  } @else {
    <div class="sso-groups">
      @for (group of groups; track group.title) {
        <div class="sso-group">
          <div class="sso-group-header">
            <i class="bi" [class]="group.icon"></i>
            <span>{{ group.title }}</span>
          </div>
          <div class="sso-group-body">
            @for (field of group.fields; track field.key) {
              <div class="sso-field">
                <div class="sso-field-icon">
                  <i class="bi" [class]="field.icon"></i>
                </div>
                <div class="sso-field-body">
                  <label>{{ field.label }}</label>
                  <div class="sso-input-wrap">
                    <input
                      [type]="field.key === 'clientSecret' ? (showSecret ? 'text' : 'password') : 'text'"
                      [(ngModel)]="sso[field.key]"
                      [disabled]="!isEditing"
                      placeholder="Not set"
                    />
                    @if (field.key === 'clientSecret') {
                      <button type="button" class="reveal-btn" (click)="showSecret = !showSecret">
                        <i class="bi" [class.bi-eye]="!showSecret" [class.bi-eye-slash]="showSecret"></i>
                      </button>
                    }
                  </div>
                  <span class="sso-help">{{ field.helpText }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
